import React, { useState } from 'react'

import MarketsIllustration from 'assets/illustrations/markets.png'
import GuyThinkingIllustration from 'assets/illustrations/guy-thinking.png'
import ArrowWithCoinsIllustration from 'assets/illustrations/arrow-with-coins.png'
import BlackboardTeachingIllustration from 'assets/illustrations/blackboard-teaching.png'
import ThreeGuysDialogIllustration from 'assets/illustrations/three-guys-dialog.png'
import Feature from 'components/Landing/GameOverview/Feature'
import ConceptButton from 'components/Landing/Concepts/ConceptButton'
import FeatureDescription from './FeatureDescription'

const TRANSLATE_KEY = 'landing.game_overview.features'

const FEATURES = [
  {
    title: `${TRANSLATE_KEY}.market_analysis.title`,
    illustration: MarketsIllustration,
    description: `${TRANSLATE_KEY}.market_analysis.description`,
    number: '#0-000'
  },
  {
    title: `${TRANSLATE_KEY}.capacity_building.title`,
    illustration: GuyThinkingIllustration,
    description: `${TRANSLATE_KEY}.capacity_building.description`,
    number: '#1-000'
  },
  {
    title: `${TRANSLATE_KEY}.execute.title`,
    illustration: ArrowWithCoinsIllustration,
    description: `${TRANSLATE_KEY}.execute.description`,
    number: '#2-000'
  },
  {
    title: `${TRANSLATE_KEY}.facilitators_feedback.title`,
    illustration: BlackboardTeachingIllustration,
    description: `${TRANSLATE_KEY}.facilitators_feedback.description`,
    number: '#3-000'
  },
  {
    title: `${TRANSLATE_KEY}.knowledge.title`,
    illustration: ThreeGuysDialogIllustration,
    description: `${TRANSLATE_KEY}.knowledge.description`,
    number: '#4-000'
  }
]

function WorkshopFeatures() {
  const [selectedFeature, setSelectedFeature] = useState(FEATURES[0])

  return (
    <div className="workshop-features">
      <div className="workshop-features__buttons">
        {FEATURES.map((feature) => (
          <ConceptButton
            key={`concept-button-${feature.title}`}
            handleOnSelect={() => setSelectedFeature(feature)}
            selected={selectedFeature.number === feature.number}
            title={feature.title}
            variant="sm"
          />
        ))}
      </div>
      <div className="workshop-features__feature">
        <Feature
          illustration={selectedFeature.illustration}
          number={selectedFeature.number}
          title={selectedFeature.title}
        />
      </div>
      <div className="workshop-features__description">
        <FeatureDescription textKey={selectedFeature.description} />
      </div>
    </div>
  )
}

export default WorkshopFeatures
